<template>
  <div
    class="v-ui-logo"
    :class="['logo', { collapsed }]"
  >
    <router-link to="/">
      <el-icon
        v-if="collapsed"
        :name="themeData.logoIcon"
        size="64"
      />
      <template v-else>
        <img
          class="logo-image"
          :src="themeData.logo"
          :alt="themeData.productName"
        />
      </template>
    </router-link>
  </div>
</template>

<script>
  import { mapState } from 'pinia';
  import useThemeStore from '@/common/store/pinia/theme';

  export default {
    name: 'UiLogo',
    props: {
      collapsed: Boolean,
    },
    computed: {
      ...mapState(useThemeStore, ['themeData'])
    }
  };
</script>

<style lang="scss" scoped>
  .logo {
    background-color: $hci-fixed-transparent;
    height: 64px;
    width: $hci-menu-width;
    align-items: center;
    justify-content: center;

    &.collapsed {
      display: flex;
      align-items: center;
      width: 64px;
      height: 64px;
      justify-content: center;
    }

    &:hover {
      opacity: 0.9;
      cursor: pointer;
    }

    .logo-image {
      width: 100%;
      max-height: 64px;
      object-fit: contain;
    }
  }
</style>
